// undefined alone enables autonomous loading. An empty/denied/failed envelope
// is still an initial response and must never turn into a startup retry.
export function readInitialSection(section) {
  if (section === undefined) return { provided: false, status: "absent", data: undefined };
  if (section && ["forbidden", "disabled", "error"].includes(section.status)) {
    return { provided: true, status: section.status, data: undefined };
  }
  if (!section || section.status !== "ok" || section.data === undefined) {
    return { provided: true, status: "error", data: undefined };
  }
  const data = section.data;
  const collection = data && !Array.isArray(data) && Array.isArray(data.data) ? data.data : data;
  const empty = collection === null || (Array.isArray(collection) && collection.length === 0)
    || (collection && typeof collection === "object" && Object.keys(collection).length === 0);
  return { provided: true, status: empty ? "empty" : "ok", data };
}
